import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';
import moment from 'moment';

const MembershipTrendsChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (!data || data.length === 0 || !chartRef.current) {
      return;
    }

    const sortedData = [...data].sort((a, b) =>
      moment(a.date).diff(moment(b.date))
    );

    const dates = sortedData.map(item => moment(item.date).format('MMM DD'));
    const newlyPurchased = sortedData.map(item => item.newly_purchased || 0);
    const renewed = sortedData.map(item => item.renewed || 0);
    const cancelled = sortedData.map(item => item.cancelled || 0);

    const ctx = chartRef.current.getContext('2d');

    const config = {
      type: 'line',
      data: {
        labels: dates,
        datasets: [
          {
            label: 'Newly Purchased',
            data: newlyPurchased,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            fill: true,
          },
          {
            label: 'Renewed',
            data: renewed,
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)',
            borderWidth: 2,
            fill: true,
          },
          {
            label: 'Cancelled',
            data: cancelled,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Membership Trends',
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        legend: {
          position: 'bottom',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Subscriptions Count',
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Date',
              },
            },
          ],
        },
      },
    };

    chartInstance.current = new Chart(ctx, config);

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <div style={{ height: '300px', position: 'relative' }}>
      {data && data.length > 0 ? (
        <canvas ref={chartRef} />
      ) : (
        <div className="text-center pt-5">No data available for the selected period</div>
      )}
    </div>
  );
};

export default MembershipTrendsChart;
